import { createReducer } from 'redux-act';
import {
  setBasket,
  selectPayment,
  setValidationErrors,
  setStatus,
  selectRequestedTime,
  keepCreatedOrder,
  setSubmittedOrder,
  updateBasket,
  setOrderLoading
} from './actions';

export const defaultBasketState: WebOrder.State.Basket = {
  status: 'none',
  items: {},
  createdOrders: {},
  validationErrors: []
};

const basketReducer = createReducer({}, defaultBasketState);
export { basketReducer };

basketReducer.on(setBasket, (state, payload) => ({
  ...payload
}));
basketReducer.on(updateBasket, (state, payload) => ({
  ...state,
  ...payload
}));

basketReducer.on(setStatus, (state, payload) => ({
  ...state,
  ...payload
}));

basketReducer.on(setValidationErrors, (state, validationErrors) => ({
  ...state,
  validationErrors
}));

basketReducer.on(selectPayment, (state, payload) => ({
  ...state,
  ...payload
}));

basketReducer.on(selectRequestedTime, (state, payload) => ({
  ...state,
  ...payload
}));

basketReducer.on(setOrderLoading, (state, orderLoading) => ({
  ...state,
  orderLoading
}));
basketReducer.on(keepCreatedOrder, (state, payload) => ({
  ...state,
  createdOrders: {
    ...state.createdOrders,
    ...payload
  }
}));
basketReducer.on(setSubmittedOrder, (state, submittedOrder) => ({
  ...state,
  submittedOrder,
  error: undefined
}));
